import React, { Component } from "react";
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { NotificationManager } from 'react-notifications';
import Select from 'react-select';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import DoneIcon from '@material-ui/icons/Done';
import ClearIcon from '@material-ui/icons/Clear';
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../../loginService/logout";

const backend = require('../../../config.js').backend;

const desigsStyles = {
    control: (provided, state) => ({
        ...provided,
        background: '#fff',
        borderColor: '#9e9e9e',
        minHeight: '30px',
        height: '30px',
        boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
        ...provided,
        height: '30px',
        padding: '0 6px'
    }),

    input: (provided, state) => ({
        ...provided,
        margin: '0px',
    }),
    indicatorSeparator: state => ({
        display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '30px',
    }),
};

const isOnlyAlphabetNumber = require('../../service/dataValidation.js').isOnlyAlphabetNumber;
const changeFloat = require('../../service/excelService.js').changeFloat;
const roundup = require('../../service/excelService.js').roundup;


// POST a fund account and PUT a budget plan
class FundAccDetailsPopup extends Component {

    constructor(props) {

        super(props);
        this.state = {
            planId: this.props.planId,
            name: '',
            per: '',
            bankAccId: null,
            bankAccName: '',

            bankAccounts: this.props.bankAccounts,
            // bankAccounts:{},
            bankAccountsDropDown: this.props.bankAccountsDropDown,
            // bankAccountsDropDown:[],

            addNew: true,
            staffid: sessionStorage.getItem('id_e'),

            loading: true

        };

        this.createNewBankAcc = this.createNewBankAcc.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleChangeBankAccount = this.handleChangeBankAccount.bind(this);
        this.handlePerChange = this.handlePerChange.bind(this);
        this.handleBankAccChange = this.handleBankAccChange.bind(this);

        this.updateBankAcc = this.updateBankAcc.bind(this);

    }


    componentDidMount() {

        if (this.props.fundAcc) {
            console.log('edit existing fund account', this.props.fundAcc);
            this.setState({ addNew: false })
            // this.setPassedFundStates();
            this.setState({
                name: this.props.fundAcc.FundAccName,
                per: this.props.fundAcc.Percentage,
                bankAccId: this.props.fundAcc.BankAccID
            }, () => {
                this.setState({ loading: false })
            })
        }
        else {
            console.log('create new fund account')
        }

    }


    handleChangeBankAccount = (account) => {
        console.log(account)
        this.setState({ bankAccId: account.value });
    }


    // Source Bank Accounts Dropdown
    renderBankAccountList = _ => {

        const { bankAccountsDropDown } = this.state;
        // console.log(bankAccountsDropDown)

        if (!this.state.addNew) {

            // console.log({value: this.props.fundAcc.BankAccID , label: this.props.fundAcc.BankAccName})

            return (

                <Select
                    className='react-select-container'
                    styles={desigsStyles}
                    options={bankAccountsDropDown}
                    defaultValue={{ value: this.props.fundAcc.BankAccID, label: this.props.fundAcc.BankAccName }}
                    isSearchable="true"
                    placeholder="Bank Account"
                    onChange={this.handleChangeBankAccount}
                />

            )

        }
        else {

            return (
                <Select
                    className='react-select-container'
                    styles={desigsStyles}
                    options={bankAccountsDropDown}
                    isSearchable="true"
                    placeholder="Bank Account"
                    onChange={this.handleChangeBankAccount}
                />
            )

        }

    }


    handelSave = _ => {

        const { name } = this.state;
        const { per } = this.state;

        // check validation of all inputs
        if (!isOnlyAlphabetNumber(name)) {
            NotificationManager.error('Please check fund name !');
        }
        else if (!this.props.validateNewPercentage(per)) {
            NotificationManager.error('Current total percentage is more than 100%. Please enter correct percentage !');
        }
        else if (this.state.bankAccId === null) {
            NotificationManager.error('Please choose a bank account!');
        }
        else {

            console.log('pass fund name and percentage checking');

            if (this.state.addNew) {
                this.createNewBankAcc();
            }
            else {
                this.updateBankAcc()
            }

        }


    }



    handelCancel = _ => {

        if (this.state.addNew) {
            this.props.closePopup();
        }
        else {
            var id = this.props.fundAcc.FundAccID;
            this.props.closeEditPopup(id);
        }
    }


    AddNewFundToSQL = _ => {

        const { name } = this.state;
        const { per } = this.state;
        const { planId } = this.state;
        const { bankAccId } = this.state;
        const { staffid } = this.state;
        var that = this;

        return new Promise(function (resolve, reject) {
            var url = `api/v1/fundacc/` + planId + `/` + staffid + `?accname=` + name + `&accper=` + per + `&bankaccid=` + bankAccId;

            return fetch(backend + url, {
                method: 'POST',
                credentials: "include"
            })
                .then(response => response.json())
                .then(data => {
                    // console.log(data);

                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else if (data.length && 'FundAccID' in data[0]) {
                        var id = data[0].FundAccID;
                        // console.log(id)
                        resolve(id);
                    }
                    else {
                        reject(data)
                    }
                })
                .catch(err => err);

        })

    }


    UpdateFundAtSQL = fundAccId => {

        const { name } = this.state;
        const { per } = this.state;
        const { bankAccId } = this.state;
        const { staffid } = this.state;
        var that = this;

        var url = `api/v1/fundacc/` + fundAccId + `/` + staffid + `?accname=` + name + `&accper=` + per + `&bankaccid=` + bankAccId;

        return new Promise(function (resolve, reject) {

            fetch(backend + url, {
                method: 'PUT',
                credentials: "include"
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    if (data.hasOwnProperty('message')) {
                        reject(data.message)
                    }
                    resolve(data);
                })
                .catch(err => err);

        })

    }



    updateBankAcc = _ => {
        var id = this.props.fundAcc.FundAccID;
        // console.log('updateBankAcc', id)

        const { name } = this.state;
        const { per } = this.state;
        const { bankAccId } = this.state;
        const { bankAccounts } = this.state;

        // if pass, add in to SQL
        this.UpdateFundAtSQL(id)
            .then(result => {
                console.log('finish udpate fund account', id, result);

                if (result.length === 0) {

                    var account = {
                        FundAccID: id,
                        FundAccName: name,
                        Percentage: per,
                        BankAccID: bankAccId,
                        BankAccName: bankAccounts[bankAccId],
                    }

                    NotificationManager.success('Fund account is updated successfully');
                    // this.props.closeEditPopup(id);
                    this.props.updateAccountList(account);

                }

            })
            .catch(err => {
                NotificationManager.error(err.toString());
            });


    }


    createNewBankAcc = _ => {

        const { name } = this.state;
        const { per } = this.state;
        const { bankAccId } = this.state;
        const { bankAccounts } = this.state;
        // console.log('name', name, 'per', per, 'bankAccId', bankAccId)

        //add in to SQL
        this.AddNewFundToSQL()
            .then(id => {
                console.log('finish adding new group to SQL', id);

                if (id) {

                    var account = {
                        FundAccID: id,
                        FundAccName: name,
                        Percentage: per,
                        BankAccID: bankAccId,
                        BankAccName: bankAccounts[bankAccId],
                    }
                    console.log(bankAccounts, bankAccId, bankAccounts[bankAccId])
                    // Add new bank account to the list
                    this.props.addToAccountList(account);
                    NotificationManager.success('Fund account is created successfully');
                    this.props.closePopup();

                }

            })
            .catch(err => {
                NotificationManager.error(err.toString());
            });



    }

    handleNameChange(event) {
        this.setState({ name: event.target.value });
    }

    handlePerChange(event) {
        this.setState({ per: event.target.value });
    }

    handleBankAccChange(event) {
        this.setState({ bankAccId: event.target.value });
    }

    render() {
        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        const { planId } = this.state
        const { loading } = this.state

        if (this.props.fundAcc && loading) {
            return (
                <tr key={planId}>
                    <td>Loading...</td>
                </tr>
            )
        }

        else {

            return (

                <tr key={planId}>
                    <td>
                        <input className="form-control" type="text" value={this.state.name} onChange={this.handleNameChange} />
                    </td>
                    <td>
                        <div>
                            <input className="form-control" type="number" placeholder="Percentage (ONLY NUMBER ACCEPTED)" value={this.state.per} onChange={this.handlePerChange} />
                        </div>
                    </td>
                    <td>
                        {this.renderBankAccountList(this.state.bankAccName, this.state.bankAccId)}
                    </td>
                    <td>

                        <DoneIcon onClick={this.handelSave} />
                        <ClearIcon onClick={this.handelCancel} />

                    </td>
                </tr>

            )

        }

    }

}


class FundsTableMgm extends Component {

    constructor(props) {

        super(props);

        this.state = {
            accounts: this.props.fundAccounts,
            showPopup: false,
            planId: this.props.planId,
            edit: {},
            bankAccountsDropDown: this.props.bankAccountsDropDown,
            bankAccounts: this.props.bankAccounts,
            staffid: sessionStorage.getItem('id_e'),
            redirectLogout: false
        }

        this.togglePopup = this.togglePopup.bind(this);
        this.handleNewFundAcc = this.handleNewFundAcc.bind(this);
        this.handelDelete = this.handelDelete.bind(this);


    }

    validateNewPercentage = (new_per) => {
        // console.log('validateNewPercentage',new_per)
        new_per = changeFloat(new_per)
        const { accounts } = this.state;
        const { edit } = this.state;
        var total_per = 0;

        accounts.forEach(function (acc, index) {
            if (!edit[acc.FundAccID]) {
                total_per += changeFloat(acc.Percentage)
            }
        });

        console.log('total per', total_per);
        if ((total_per + new_per) > 100) return false
        else return true;

    }

    calculateLeftPercentage = () => {

        const { accounts } = this.state;
        var total_per = 0;

        accounts.forEach(function (acc, index) {
            total_per += changeFloat(acc.Percentage)
        });

        return (roundup(100 - total_per));

    }


    deleteFromAccountList = id => {
        this.setState({ accounts: this.state.accounts.filter(account => account.FundAccID !== id) })
    }

    handelDelete = (accountId, accountName) => {

        const { staffid } = this.state;
        // console.log('deleteAcc', accountId, accountName);
        // windows warning
        var answer = window.confirm("Are you sure you want to delete bank account " + accountName + " ?");


        if (answer) {

            fetch(backend + `api/v1/fundacc/` + accountId + `/` + staffid, {
                method: 'DELETE',
                credentials: "include"
            })
                .then(response => response.json())
                .then((response) => {
                    if (response.redirect) {
                        this.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else if (response.Error !== undefined) {
                        NotificationManager.error((response.Error).toString());
                    }
                    else {
                        NotificationManager.success('Fund account is deleted successfully');
                        this.deleteFromAccountList(accountId);
                    }

                })
                .catch(err => console.error(err));

        } else {
            // Do nothing!
        }


    }

    handleEdit = id => {

        var { edit } = this.state;
        edit[id] = true;
        this.setState({ edit: edit })
    }

    handCancel = id => {

        var { edit } = this.state;
        edit[id] = false;
        this.setState({ edit: edit })

    }


    renderFundAcc = fundAcc => {
        var fundId = fundAcc.FundAccID;
        var row
        const { planId } = this.state;
        const { edit } = this.state;

        if (edit[fundId]) {
            row = (
                <FundAccDetailsPopup
                    key={fundId}
                    closeEditPopup={this.handCancel.bind(this)}
                    updateAccountList={this.updateAccountList.bind(this)}
                    planId={planId}
                    validateNewPercentage={this.validateNewPercentage}
                    fundAcc={fundAcc}
                    bankAccounts={this.state.bankAccounts}
                    bankAccountsDropDown={this.state.bankAccountsDropDown}
                />)
        }
        else {
            row = (
                <tr key={fundId}>
                    <td>{fundAcc.FundAccName}</td>
                    <td>{fundAcc.Percentage}</td>
                    <td>{fundAcc.BankAccName}</td>
                    <td>
                        <EditIcon onClick={() => this.handleEdit(fundId)} />
                        <DeleteIcon onClick={() => this.handelDelete(fundId, fundAcc.FundAccName)} />

                    </td>
                </tr>
            )

        }

        return row

    }


    addToAccountList = (account) => {

        if (account) {
            // console.log('addToAccountList', account.FundAccID, account.FundAccName);

            var { accounts } = this.state;
            accounts.push(account)
            this.setState({ accounts: accounts })
        }

    }

    updateAccountList = (account) => {

        // console.log('updateAccountList', account)
        this.props.refresh();
    }

    togglePopup = _ => {
        // console.log('togglePopup');
        this.setState({ showPopup: !this.state.showPopup });
    }


    handleNewFundAcc = _ => {
        this.togglePopup();
    }



    render() {
        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        const { accounts } = this.state;
        const { planId } = this.state;

        let content = (
            <div className='fund-acc-list'>
                <div>
                    <AddCircleIcon onClick={this.handleNewFundAcc} />
                    <label>New Fund Account</label>

                </div>
                <table className="table table-striped table-hover ">
                    <tbody>
                        <tr>
                            <th className='name'>Destination Funds</th>
                            <th className='per'>Percentage(%)</th>
                            <th className='acc'>Bank Account</th>
                            <th>Actions</th>
                        </tr>

                        {accounts.map(this.renderFundAcc)}
                        {(this.state.showPopup) ?
                            <FundAccDetailsPopup
                                closePopup={this.togglePopup.bind(this)}
                                addToAccountList={this.addToAccountList}
                                planId={planId}
                                validateNewPercentage={this.validateNewPercentage}
                                bankAccounts={this.state.bankAccounts}
                                bankAccountsDropDown={this.state.bankAccountsDropDown}
                            />
                            : null
                        }
                        <tr>
                            <td></td>
                            <td>Left Percentage: {this.calculateLeftPercentage()}</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>

        )

        return (content);

    }


}

export default FundsTableMgm;